import { Skeleton } from '@/components/ui/Skeleton';

export function BunkerPriceSkeleton() {
  return (
    <div className="space-y-2">
      {[1, 2, 3, 4, 5].map((index) => (
        <div
          key={index}
          className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800"
        >
          {/* Skeleton Header */}
          <div className="px-4 py-4 sm:px-6">
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0 flex-1 space-y-3">
                {/* Port Name */}
                <Skeleton className="h-6 w-32" />

                {/* Price Grid */}
                <div className="space-y-2">
                  {/* Headers */}
                  <div className="hidden grid-cols-4 gap-4 sm:grid">
                    <Skeleton className="h-3 w-16" />
                    <Skeleton className="h-3 w-12" />
                    <Skeleton className="h-3 w-12" />
                    <Skeleton className="h-3 w-14" />
                  </div>

                  {/* Data Rows */}
                  {[1, 2, 3].map((row) => (
                    <div key={row} className="grid grid-cols-2 gap-2 sm:grid-cols-4 sm:gap-4">
                      <Skeleton className="h-4 w-12" />
                      <Skeleton className="h-4 w-20" />
                      <Skeleton className="h-4 w-16" />
                      <Skeleton className="hidden h-4 w-12 sm:block" />
                    </div>
                  ))}
                </div>
              </div>

              {/* Expand Icon */}
              <Skeleton className="h-5 w-5" variant="circular" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
